var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Youtube"),React.createElement("path",{"d":"M17.799 6.403c-.405-.037-.797-.078-1.186-.117C15.177 6.139 13.82 6 12 6c-1.76 0-3.235.148-4.662.292-.376.038-.753.075-1.137.111C4.967 6.517 4 7.681 4 9.053v6.894c0 1.372.967 2.536 2.201 2.65.4.037.79.077 1.177.116C8.825 18.861 10.191 19 12 19c1.86 0 3.185-.137 4.588-.282.396-.041.795-.082 1.211-.121 1.234-.114 2.201-1.278 2.201-2.65V9.053c0-1.372-.967-2.536-2.201-2.65zm-3.03 6.328-5.235 2.98a.308.308 0 0 1-.295.004.268.268 0 0 1-.148-.236V9.521c0-.098.057-.189.148-.236a.31.31 0 0 1 .295.005l5.236 2.979c.086.049.14.137.14.23a.268.268 0 0 1-.14.232z","fill":"currentColor","fillRule":"nonzero","key":1})]);
}

Youtube.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Youtube;

Youtube.default = Youtube;
